export const randomize = (pt, min, max, degree) => {
    // given a data point
    let section = degree * Math.abs(max - min);
    let ptMin = pt - (section / 2.0);
    return ptMin + Math.random() * section;
};

